import { extractFirstPart, extractLastPart } from '/@/modules/core/app/helpers/StringHelper';
import { fileSize } from '/@/modules/core/app/helpers/FileHelper';

Object.defineProperty(File.prototype, 'extension', {
  get() {
    return extractLastPart(extractFirstPart(this.name, '?'), '.');
  }
});

Object.defineProperty(File.prototype, 'formattedSize', {
  get() {
    return fileSize(this.size);
  }
});

/**
 * @param {number} size - in MB
 * @param {number} sizeLimit - in MB
 * @returns {boolean}
 */
File.isWithinSizeLimit = function (size, sizeLimit) {
  return size <= sizeLimit * (1024 * 1024);
};

/**
 * @param {string} url
 * @returns {Promise<File>}
 */
File.createFileFromUrl = async function (url) {
  const blob = await File.createBlobFromUrl(url);

  return new this([blob], extractLastPart(url));
};

/**
 * @param {string} url
 * @returns {Promise<Blob>}
 */
File.createBlobFromUrl = async function (url) {
  const data = await fetch(url);
  return data.blob();
};

/**
 * @param {string} name
 * @returns {File}
 */
File.createDummy = function (name) {
  return new this([], name);
};

/**
 * @param {string} url
 * @returns {File}
 */
File.createDummyFromUrl = function (url) {
  return File.createDummy(extractLastPart(url));
};
